module.exports = __webpack_public_path__ + "static/media/good.31ddade0.png";